<div class="card">

	<div class="card-body">
		<h5 class="card-title">Company management</h5>
		<ng-container *ngIf="viewModel$ | async as viewModel">
			<dx-accordion [collapsible]="true">
				<!-- *ngIf="!this.linkInfo.frontendPage" -->
				<dxi-item *ngIf="!viewModel.companyIsMainCompany" title="Company configuration">
					<div class="card-body">
						<app-shell-company-configuration [isCompanyOwner]="viewModel.isCompanyOwner"
							[canManageCompany]="viewModel.canManageCompany"></app-shell-company-configuration>
					</div>
				</dxi-item>
				<dxi-item *ngIf="!viewModel.companyIsMainCompany" title="Company user management">
					<div class="card-body">
						<app-shell-user-permissions-management [isCompanyOwner]="viewModel.isCompanyOwner"
							[canAssignUserManagementPermissions]="viewModel.canAssignUserManagementPermissions"></app-shell-user-permissions-management>
					</div>
				</dxi-item>
				<dxi-item *ngIf="viewModel.canAssignUserManagementPermissions" title="Admin company user management">
					<div class="card-body">
						<app-shell-user-permissions-management-admin>
						</app-shell-user-permissions-management-admin>
					</div>
				</dxi-item>
			</dx-accordion>
		</ng-container>
	</div>
</div>
